__turbopack_context__.v({
  "description": "NewsCard-module-scss-module__uVrx0q__description",
  "newsCard": "NewsCard-module-scss-module__uVrx0q__newsCard",
  "subtitle": "NewsCard-module-scss-module__uVrx0q__subtitle",
});
